import type { LandingPageConfigOptions } from "landing/objects/LandingPageConfig";

export const MobileOnlyOptions: LandingPageConfigOptions = {
  hidesEmail: true,
  hidesFirstName: true,
  hidesLastName: true,
};
